export default __webpack_public_path__ + "76b6450ec312c5105ce5035b0d8cf5bc.svg";